// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/notesEditor/trash.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/burger.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.FullAnalysis_folder{
    display: flex;
    align-items: center;
    gap: 14px;
    width: calc((100% - (var(--cols) - 1) * 5px) / var(--cols));
    padding: 5px;
    position: relative;

    border: 1px solid #ccc0;
}

.FullAnalysis_folder_sideMenu{
    position: absolute;
    top: -22px;
    right: -4px;
    padding: 2px 5px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid#ccc;

    display: flex;
    gap: 5px;
    pointer-events: none;
    opacity: 0;
    transition-duration: 500ms;
}

.FullAnalysis_folder:hover .FullAnalysis_folder_sideMenu{
    pointer-events: all;
    opacity: 1;
    transition-duration: 200ms;
}

.FullAnalysis_folder:hover{
    border: 1px solid #ccc;
    border-radius: 5px;
}

.FullAnalysis_folder_sideMenu_button{
    font-size: 0px;
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 14px 14px;
    border-radius: 3px;
}

.FullAnalysis_folder_name{
    cursor: text;
    word-break: break-all;
}

.FullAnalysis_folder_sideMenu_button:hover{
    background-color: #ccc;
}

.FullAnalysis_folder_sideMenu_button--delete{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.7;
}

.FullAnalysis_folder_sideMenu_button--edit{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.FullAnalysis_folder_sideMenu_button--more{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.FullAnalysis_folder__fileIndicator{
    position: absolute;
    top: -2px;
    left: -2px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
}

.FullAnalysis_folder_icon{
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisFolder.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2DAA2D;IAC3D,YAAY;IACZ,kBAAkB;;IAElB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;;IAErB,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,yDAAiE;IACjE,4BAA4B;IAC5B,kCAAkC;IAClC,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yDAAiE;IACjE,YAAY;AAChB;;AAEA;IACI,yDAAoD;AACxD;;AAEA;IACI,yDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["\n.FullAnalysis_folder{\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    width: calc((100% - (var(--cols) - 1) * 5px) / var(--cols));\n    padding: 5px;\n    position: relative;\n\n    border: 1px solid #ccc0;\n}\n\n.FullAnalysis_folder_sideMenu{\n    position: absolute;\n    top: -22px;\n    right: -4px;\n    padding: 2px 5px;\n    border-radius: 4px;\n    background-color: #fff;\n    border: 1px solid#ccc;\n\n    display: flex;\n    gap: 5px;\n    pointer-events: none;\n    opacity: 0;\n    transition-duration: 500ms;\n}\n\n.FullAnalysis_folder:hover .FullAnalysis_folder_sideMenu{\n    pointer-events: all;\n    opacity: 1;\n    transition-duration: 200ms;\n}\n\n.FullAnalysis_folder:hover{\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.FullAnalysis_folder_sideMenu_button{\n    font-size: 0px;\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n\n    background-image: url(\"../../../../assets/notesEditor/trash.svg\");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 14px 14px;\n    border-radius: 3px;\n}\n\n.FullAnalysis_folder_name{\n    cursor: text;\n    word-break: break-all;\n}\n\n.FullAnalysis_folder_sideMenu_button:hover{\n    background-color: #ccc;\n}\n\n.FullAnalysis_folder_sideMenu_button--delete{\n    background-image: url(\"../../../../assets/notesEditor/trash.svg\");\n    opacity: 0.7;\n}\n\n.FullAnalysis_folder_sideMenu_button--edit{\n    background-image: url(\"../../../../assets/edit.svg\");\n}\n\n.FullAnalysis_folder_sideMenu_button--more{\n    background-image: url(\"../../../../assets/burger.png\");\n}\n\n.FullAnalysis_folder__fileIndicator{\n    position: absolute;\n    top: -2px;\n    left: -2px;\n    font-size: 12px;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 3px;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #ddd;\n}\n\n.FullAnalysis_folder_icon{\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
